// Source https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
export const HTTP_STATUS_CODE_OK = 200
export const HTTP_STATUS_CODE_NO_CONTENT = 204
export const HTTP_STATUS_CODE_MOVED_PERMANENTLY = 301
export const HTTP_STATUS_CODE_FOUND = 302
export const HTTP_STATUS_CODE_BAD_REQUEST = 400
export const HTTP_STATUS_CODE_NOT_FOUND = 404
export const HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR = 500
export const HTTP_STATUS_CODE_UNAUTHORIZED = 401
export const HTTP_STATUS_CODE_FORBIDDEN = 403
